
namespace RioERP.Reports {
    export class OrderDetailedReportColumns {
        static columnsKey = 'Reports.OrderDetailedReport';
    }
}